module.exports = require("@swa-ui/core/src/Textarea/Textarea.module.scss");